export default "__VITE_ASSET__c6af45fe__"